import { AlertCircle } from 'lucide-react';
import { cn } from '@/lib/utils';

// Warns that uploaded documents are not searchable in Eva until they have been
// submitted for review, approved, and ingested. Without `count` it reads as a
// generic warning on the bulk-upload completion screen (above the "What happens
// next" steps); with `count` it becomes a persistent, count-driven reminder on
// the KB Content page so lingering drafts aren't accidentally left un-ingested.
// (EIP-196)
export default function KbNotIngestedNotice({ count, className, ...props }) {
  const message =
    count == null
      ? 'These documents are not yet available to Eva. They won’t be searchable in chat until you submit them for review, approve them, and start ingestion.'
      : `You have ${count} document${count === 1 ? '' : 's'} in process that ${
          count === 1 ? 'isn’t' : 'aren’t'
        } available to Eva yet. Submit, approve, and start ingestion to make ${
          count === 1 ? 'it' : 'them'
        } searchable in chat.`;

  return (
    <div
      role="status"
      className={cn(
        'flex items-start gap-2 rounded-xl border border-warning/30 bg-warning/10 p-4 text-sm text-warning',
        className
      )}
      {...props}
    >
      <AlertCircle className="mt-0.5 h-4 w-4 shrink-0" aria-hidden="true" />
      <p className="font-medium">{message}</p>
    </div>
  );
}
